import { defineStore } from "pinia";
import { login } from "@/api/auth/login";
import { getJWT, removeJWT } from "@/utils/token";
import envs from "@/envs";

export const useUserStore = defineStore("user", {
  state: () => ({
    userId: "",
    userName: "",
    userVendCd: "",
    token: "",
    roles: [],
    buttonPermission: "",
    myMenu: [],
  }),
  persist: {
    enabled: true,
    strategies: [
      {
        storage: localStorage, // 또는 sessionStorage
        paths: ["userId", "userName", "token"], // 저장할 항목 선택
      },
    ],
  },
  actions: {
    async loginByPassword(userInfo) {
      try {
        const searchParams = {
          CUID: `${userInfo.userId?.trim()}@${envs.companyCode}`,
          PASSWORD: userInfo.userPassword?.trim(),
          NEWPASSWORD: "",
        };

        const res = await login(searchParams);

        console.log('res._Result', res._Result);
        
        this.userId = res._Result.Userid;
        this.userName = res._Result.USER_KR_NAME;
        this.userVendCd = res._Result.USER_EN_NAME;
        this.token = getJWT(); // 쿠키나 로컬스토리지에서 토큰 가져오기

        return res;
      } catch (error) {
        console.error("loginByPassword 실패:", error);
        throw error;
      }
    },

    clearSession() {
      this.userId = "";
      this.userName = "";
      this.userVendCd = "";
      this.token = "";
      this.roles = [];
      this.buttonPermission = "";
      this.myMenu = [];
      removeJWT();
    },
  },
});
